// removed by extract-text-webpack-plugin
module.exports = {"modal":"L9x3tmoMLwkSu4bS8iSZl","failModalContentWrapper":"_1VCh4gN-1oXPjACzT0m1CW","titleWrapper":"_2kMSNWibZb-31J8afJoQ4d","failModalTitle":"ILBgXTeSRub5IihV2A5B9","failModalSubTitle":"_2fkhvrRlqBzZ4rFKVnt3PQ","failModalButton":"_3clK9hPgylBUKBQzG4Ekok"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthenticationContainer/ModalError/ModalError.scss
// module id = 1805
// module chunks = 0